

















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { status } from "../../api/status/status";

import Moment from "moment";

@Component({
  props: { details: { enddate: "", selectedStatus: "" } as any },
  model: { prop: "details", event: "change" }
})
export default class StatusSelector extends Vue {
  public statuses: any[] = [];

  public async getStatusList() {
    await status
      .getAllStatuses(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then(resp => {
          let i = 0;
          while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
            this.statuses.push({
              value: JSON.parse(JSON.stringify(resp))[i].id,
              label: JSON.parse(JSON.stringify(resp))[i].literal
            });
            i++;
          }
        });
      });
  }
public Completiondate(row: any) {
    // if (row.status.enddate === undefined) {
    //   return "";
    // }
    // console.log("123456")
    // return Moment(row.status.enddate).format("DD/MM/YYYY HH:mm");

  return "x"
  }


  public async mounted() {
    await this.getStatusList();
  }
}
